/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 배터리 상태 조회 응답
 */
export type GetEvBatteryStatusResponse = {
  /**
   * SoC
   */
  soc: number;
  /**
   * SoH
   */
  soh: number;
  /**
   * 마지막 충전 날짜 (yyyyMMdd)
   */
  lastChargedDate: string;
  /**
   * unit 타입( CCU / HU )
   */
  unit: GetEvBatteryStatusResponse.unit;
};
export namespace GetEvBatteryStatusResponse {
  /**
   * unit 타입( CCU / HU )
   */
  export enum unit {
    CCU = 'CCU',
    HU = 'HU',
  }
}

